<template>
	<div class="key-indicators">
		<!-- CO2 per Turnover -->
		<v-card class="indicator">
			<div class="icon-circle">
				<i class="fas fa-sync-alt fa-3x"></i>
				<i class="fas fa-euro-sign overlay-icon"></i>
			</div>
			<p><span class="value">{{ roundedData[0] }}</span> Kg</p>
			<p class="label">CO₂ per Million EUR</p>
		</v-card>

		<!-- CO2 per Man-Year -->
		<v-card class="indicator">
			<div class="icon-circle">
				<i class="fas fa-user fa-2x"></i>
			</div>
			<p><span class="value">{{ roundedData[1] }}</span> Kg</p>
			<p class="label">CO₂ per man-year</p>
		</v-card>

		<!-- Trees to Grow -->
		<v-card class="indicator">
			<div class="icon-circle">
				<i class="fas fa-tree fa-2x"></i>
			</div>
			<p class="value">{{ roundedData[2] }}</p>
			<p class="label">Trees need to grow to be carbon neutral</p>
		</v-card>
	</div>
</template>

<script>
export default {
	name: "KeyIndicators",
	props: {
		data: {
			type: Array,
			required: true,
		},
	},
	mounted() {
		console.log(this.data)
	},
	computed: {
		roundedData() {
			return [
				Math.round((this.data?.[0] ?? 0)), // Prevent NaN
				Math.round(this.data?.[1] ?? 0), // Ensure it's always a number
				Math.ceil(this.data?.[2] ?? 0) // Always round up
			]
		},
	},
}
</script>

<style scoped>
.key-indicators {
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	background: linear-gradient(135deg, #e2ebf0, #f4f6fb);
	padding: 40px 20px;
	gap: 20px;
}

.indicator {
	text-align: center;
	position: relative;
	padding: 30px 20px;
	width: 220px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
	border-radius: 20px;
	background: #ffffff;
	transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.indicator:hover {
	transform: translateY(-10px);
	box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
}
.icon-circle .fa-sync-alt  {
    color: rgb(30, 124, 131);
}
.icon-circle .fa-tree  {
    color: rgb(30, 124, 131);
}
.icon-circle .fa-user  {
    color: rgb(30, 124, 131);
}
.icon-circle {
	width: 90px;
	height: 90px;
	background: radial-gradient(circle at top left, rgb(248, 181, 94), rgb(233, 137, 27));
	border-radius: 100%; /* Fully rounded circle */
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	margin: 0 auto 15px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.overlay-icon {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-size: 22px;
	color: rgb(30, 124, 131);
}

.value {
	font-size: 26px;
	font-weight: bold;
	color: #333;
	margin-top: 5px;
}

.label {
	font-size: 15px;
	color: #555;
	margin-top: 8px;
	line-height: 1.4;
}
</style>
